import { useState } from 'react'
import { PillsInput, Pill, Group } from '@mantine/core'

export default function TagView(props) {

    const [newTag, setNewTag] = useState('')

    function addTag() {
        if (props.onAddTag && newTag) {
            props.onAddTag(newTag)
            setNewTag('')
        }
    }

    function handleKeyPress(e) {
        if (e.key === 'Enter') {
            e.preventDefault()
            addTag()
        }
    }

    function updateNewTag(e) {
        const text = e.target.value.replaceAll(/[^a-zA-Z0-9\-_]/g, '')
        setNewTag(text)
    }

    if (props.editing) {
        return (
            <PillsInput
                size="sm"
                onClick={(e) => e.stopPropagation()}
            >
                <Pill.Group>
                    {props.tags?.map(tag => (
                        <Pill
                            key={tag}
                            withRemoveButton
                            onRemove={() => props.onRemoveTag(tag)}
                            bg="cyan.9"
                        >
                            {tag}
                        </Pill>
                    ))}
                    <PillsInput.Field
                        value={newTag}
                        onChange={updateNewTag}
                        onKeyDown={handleKeyPress}
                        placeholder="Add tag..."
                        onBlur={() => {
                            if (newTag) addTag()
                        }}
                    />
                </Pill.Group>
            </PillsInput>
        )
    }

    // Non-editing mode - just display pills
    return (
        <Group gap="xs" wrap="wrap" onClick={props.onClick} style={{ minHeight: '28px' }}>
            {props.tags?.map(tag => (
                <Pill key={tag} bg="cyan.9">
                    {tag}
                </Pill>
            ))}
            {(!props.tags || props.tags.length === 0) && (
                <Pill bg="dark.6" style={{ cursor: 'pointer' }}>
                    Click to add tags
                </Pill>
            )}
        </Group>
    )
}
